import React, { useState } from 'react'
import { UsuarioPerfilBox } from './styles'
import { Tooltip } from "@material-ui/core";
import { CircularProgress } from "@material-ui/core";
import CreateIcon from '@material-ui/icons/Create';
import RemoveIcon from '@material-ui/icons/Remove';
import { cpfCnpj, isNullReturnHyphen } from "../../../functions"
import ControleAcessoService from "../../../services/ControleAcessoService"
import { useSnackbar } from "notistack"
import ManutencaoPerfil from '../ManutencaoPerfil';
import DialogRevogar from '../DialogRevogar';
import TipoOperacao from './../../../../src/enums/tipoOperacao'
import webconfig from "../../../webconfig.json"

export default function UsuarioPerfil({
    usuario,
    orgao,
    setAtualizarConsulta,
    setFoiRevogacao }) {

    const [loading, setLoading] = useState(false)
    const [loadingProcesso, setLoadingProcesso] = useState(false)
    const [orgaoJurisdicionado, setOrgaoJurisdicionado] = useState(orgao)
    const { enqueueSnackbar } = useSnackbar()

    const [modalUsuario, setModalUsuario] = useState({
        open: false,
        obj: {}
    })

    const [dialogRevogar, setDialogRevogar] = useState({
        id: 0,
        open: false,
        delete: false,
    });

    const RevogaAcesso = () => {
        setDialogRevogar({
            id: usuario.id,
            open: true,
            delete: true
        });
    }

    const UsuarioPossuiAcessoComoGestorOrgao = (usuario) => {
        for (let indice = 0; indice < usuario.listaOrgaosJurisdicionados.length; indice++) {
            if (usuario.listaOrgaosJurisdicionados[indice].setorIdOrgaoJurisdicionado === orgaoJurisdicionado.id &&
                usuario.listaOrgaosJurisdicionados[indice].ehRegistroSolicitacaoGestor === true)
                return true
        }
        return false
    }

    const EditarAcesso = () => {
        setLoading(true)
        let _ehRegistroSolicitacaoGestor = UsuarioPossuiAcessoComoGestorOrgao(usuario)

        ControleAcessoService.ConsultaPorId(usuario.id, _ehRegistroSolicitacaoGestor)
            .then(response => {
                setLoading(false)
                setModalUsuario({
                    open: true,
                    obj: response.data
                })
            })
            .catch(error => {
                setLoading(false)
                if (error.response && error.response.data) {
                    if (error.response.status === 422) {
                        enqueueSnackbar(`${error.response.data.detail}`, { variant: "error", autoHideDuration: webconfig.snackbarAutoHideDuration })
                    }
                    else if (error.response.status === 500) {
                        enqueueSnackbar(`Ocorreu um erro inesperado. Contate o suporte (${error.response.data.detail})`, { variant: "error", autoHideDuration: webconfig.snackbarAutoHideDuration })
                    }
                    else {
                        enqueueSnackbar(`${error.response.data.detail}`, { variant: "error", autoHideDuration: webconfig.snackbarAutoHideDuration })
                    }
                }
                else {
                    enqueueSnackbar(`Ocorreu um erro inesperado. Contate o suporte (${error.message})`, { variant: "error", autoHideDuration: webconfig.snackbarAutoHideDuration })
                }
            })
    }

    return (
        <>
            <ManutencaoPerfil
                tipoOperacao={TipoOperacao.ALTERACAO}
                modalUsuario={modalUsuario}
                setModalUsuario={setModalUsuario}
                orgaoUsuarioLogado={orgaoJurisdicionado}
                setAtualizarConsulta={setAtualizarConsulta}
            />

            <DialogRevogar
                dialogRevogar={dialogRevogar}
                setDialogRevogar={setDialogRevogar}
                setAtualizarConsulta={setAtualizarConsulta}
                setFoiRevogacao={setFoiRevogacao}
            />

            <UsuarioPerfilBox.Desktop id="ComunicacaoBox" >
                <UsuarioPerfilBox.Content>
                    <UsuarioPerfilBox.Documento>
                        <UsuarioPerfilBox.Informacao>
                            <span title="Nome do usuário">Nome</span>
                            <UsuarioPerfilBox.DadoComunicacao className="txt-oficio" title={isNullReturnHyphen(usuario.nome)}>{isNullReturnHyphen(usuario.nome)}</UsuarioPerfilBox.DadoComunicacao>
                        </UsuarioPerfilBox.Informacao>
                        <UsuarioPerfilBox.Informacao>
                            <span title="Perfis de acessos do usuário">Perfis</span>
                            <UsuarioPerfilBox.DadoComunicacao className="txt-oficio" title={isNullReturnHyphen(usuario.listaPerfis.map((x) => x.nome).join(', '))}>{isNullReturnHyphen(usuario.listaPerfis.map((x) => x.nome).join(', '))}</UsuarioPerfilBox.DadoComunicacao>
                        </UsuarioPerfilBox.Informacao>
                        <UsuarioPerfilBox.Informacao>
                            <span title="CPF do usuário">CPF</span>
                            <UsuarioPerfilBox.DadoComunicacao className="txt-oficio" title={cpfCnpj(isNullReturnHyphen(usuario.cpf))}>{cpfCnpj(isNullReturnHyphen(usuario.cpf))}</UsuarioPerfilBox.DadoComunicacao>
                        </UsuarioPerfilBox.Informacao>
                        <UsuarioPerfilBox.Informacao>
                            <span title="E-mail do usuário">E-mail</span>
                            <UsuarioPerfilBox.DadoComunicacao className="txt-oficio" title={isNullReturnHyphen(usuario.email)}>{isNullReturnHyphen(usuario.email)}</UsuarioPerfilBox.DadoComunicacao>
                        </UsuarioPerfilBox.Informacao>
                    </UsuarioPerfilBox.Documento>

                    <UsuarioPerfilBox.Acao>
                        {usuario && UsuarioPossuiAcessoComoGestorOrgao(usuario) === false && (
                            <Tooltip title="Revogar Acesso" placement="top">
                                <UsuarioPerfilBox.BotaoAcao
                                    className="bg-hover--ui-color-03 border--ui-color-03 color--ui-color-03 color-hover--ui-white"
                                    disabled={loadingProcesso}
                                    title='Revogar Acesso'
                                    onClick={RevogaAcesso}
                                >
                                    {
                                        loading
                                            ?
                                            <CircularProgress
                                                size={22}
                                                style={{
                                                    color: '#ffffff'
                                                }} />
                                            : <RemoveIcon />
                                    }
                                </UsuarioPerfilBox.BotaoAcao>
                            </Tooltip>
                        )}

                        <Tooltip title="Editar Acesso" placement="top">
                            <UsuarioPerfilBox.BotaoAcao
                                className="bg-hover--ui-color-10 border--ui-color-10 color--ui-color-10 color-hover--ui-white"
                                disabled={loadingProcesso}
                                title='Editar Acesso'
                                onClick={EditarAcesso}
                            >
                                {
                                    loading
                                        ?
                                        <CircularProgress
                                            size={22}
                                            style={{
                                                color: '#ffffff'
                                            }} />
                                        : <CreateIcon />
                                }
                            </UsuarioPerfilBox.BotaoAcao>
                        </Tooltip>
                    </UsuarioPerfilBox.Acao>
                </UsuarioPerfilBox.Content>
            </UsuarioPerfilBox.Desktop>
        </>
    )
}